<div class="add-comment-form">
    <div>
        <textarea name="rule-comment" rows="4"
            [(ngModel)]="newComment"
            (change)="newComment = newComment.trim()"></textarea>
    </div>
    <div class="text-right">
        <button class="btn btn-sm btn-submit btn-secondary" 
            (click)="onCreateComment()" 
            [disabled]="processing ||
                    newComment === null ||
                    newComment.trim().length <= 0">
            Post Comment
            <div *ngIf="processing" class="loading-wrapper">
                <i class="fas fa-spinner"></i>
            </div>
        </button>
    </div>
</div>